<template>
	<div class="promotion-item" v-if="promotion">

	<img :src="promotion.banner_image" width="100%" />

		<div class="post-box" v-if="more == 1">
			<div class="post-content">
				<h6 class="post-title" style="display: none">
					{{ promotion.title }}
				</h6>
				<div class="post-text" style="display: none" v-html="promotion.description">

				</div>
				<div class="post-foot" style="display: none">
					<router-link :to="{ params: { id: promotion.id } }" class="post-link" exact-active-class="active" exact>
						<span>{{ t.details_rules }}</span><i class="os-icon os-icon-arrow-right7"></i>
					</router-link>
				</div>
			</div>
		</div>

		<div class="post-box" v-if="more == 0">
			<div class="post-media" :style="{ backgroundImage: 'url('+promotion.banner_image+')'}"></div>
			<div class="post-content text-left">
				<h6 class="post-title">
					{{ promotion.title }}
				</h6>
				<div class="post-text" v-html="promotion.description">

				</div>

				<div class="post-text" v-html="promotion.terms">

				</div>
			</div>
		</div>


	</div>
</template>

<script>
    export default {
        name: 'promotionItem',
        props: {
            promotion: {
                default: null,
            },
	        more: {
                default: 1
	        }
        },
        data () {
            return {
                msg: '',
                t: this.$root.t,
                session:  this.$root.session
            }
        },
	    methods:
	    {
	        moreText () {
	            return (this.more > 0) ? this.t.promotion.title.click_for_more : this.t.promotion.title.terms_of_contract
	        }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.promotion-item img {
	border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/promotion/item.vue